import {BadgeProps, ButtonProps} from '@mantine/core';

export enum HomepagePreferences {
  HOMEPAGE_CARD_LAYOUT_V2 = 'HOMEPAGE_CARD_LAYOUT_V2',
  MY_WORK_SELECTED_CATEGORY_V2 = 'MY_WORK_SELECTED_CATEGORY_V2',
  MY_WORK_ENTRIES_STATUS_FILTER_V2 = 'MY_WORK_ENTRIES_STATUS_FILTER_V2',
  MY_WORK_WORKSHEETS_STATUS_FILTER_V2 = 'MY_WORK_WORKSHEETS_STATUS_FILTER_V2',
  MY_WORK_TASKS_STATUS_FILTER_V2 = 'MY_WORK_TASKS_STATUS_FILTER_V2',
  MY_WORK_TEMPLATES_STATUS_FILTER = 'MY_WORK_TEMPLATES_STATUS_FILTER_V2',
}

export const HOMEPAGE_PATH = '/editor/homepage';

export const HOMEPAGE_SECTION_TEST_COMPONENT = {
  ACTIVITY: 'ActivitySection',
  RECENTS: 'RecentsSection',
  WORKLISTS: 'WorklistsSection',
  MY_WORK: 'MyWorkSection',
  AI: 'AISection',
  WELCOME: 'WelcomeSection',
} as const;

export const HOMEPAGE_BANNER_TEST_COMPONENT = {
  ORGANIZATION_INVITE: 'OrganizationInviteBanner',
} as const;

export const INITIAL_ROWS_TO_DISPLAY = 10;
export const LOADING_SKELETON_ROW_COUNT = INITIAL_ROWS_TO_DISPLAY / 2;
export const MAX_ROWS_TO_DISPLAY = 25;

/** Card section row height in px; kept in sync with {@link CardSection} row layout. */
export const CARD_SECTION_ROW_HEIGHT_PX = 38;

/** Fixed height for homepage card empty states; matches the loading skeleton area. */
export const EMPTY_CARD_SECTION_HEIGHT_PX = CARD_SECTION_ROW_HEIGHT_PX * LOADING_SKELETON_ROW_COUNT;

export const DEFAULT_BADGE_PROPS: BadgeProps = {
  size: 'sm',
  radius: 'xl',
};

export const DEFAULT_SECTION_BUTTON_PROPS: ButtonProps = {
  variant: 'default',
  size: 'md',
  radius: 'lg',
  fw: 500,
};

const COLUMN_SPACING_INT = 26;
export const COLUMN_SPACING = `${COLUMN_SPACING_INT}px`;
const MAX_COLUMN_WIDTH = 640;
export const MAX_CONTENT_WIDTH = MAX_COLUMN_WIDTH * 2 + COLUMN_SPACING_INT;

/** Below this width, card section rows use a compact layout. */
export const COMPACT_CARD_SECTION_MAX_WIDTH = 450;

/** Below this width, homepage cards stack in a single column. */
export const SINGLE_COLUMN_MODE_MAX_WIDTH = 800;
